import SchoolIcon from "@mui/icons-material/School";
import WorkIcon from "@mui/icons-material/Work";

export const experiences = [
  {
    title: "Sr. React Native Developer",
    subTitle: "smartData Enterprises, Mohali, Punjab",
    body: "Successfully developed 4-5 high-performance mobile apps using React Native and Expo CLI, ensuring a seamless user experience. Conducted training on React Native and Redux Toolkit for 8 trainees and collaborated with international clients to gather requirements and deliver tailored solutions.",
    icon: <WorkIcon />,
    date: "Mar 2023 - Mar 2025",
  },
  {
    title: "Software Engineer (Frontend Developer)",
    subTitle: "Benytsys, Mohali, Punjab",
    body: "Developed multiple websites and mobile apps using technologies like HTML5, CSS3, JavaScript, React, React Native, Angular, and Nest.js.",
    icon: <WorkIcon />,
    date: "Aug 2020 - Mar 2023",
  },
  {
    title: "Home Tutor",
    subTitle: "Star Tutorials, Jalandhar, Punjab",
    body: "Taught Maths, Science and Coding to Students till 10th class.",
    icon: <WorkIcon />,
    date: "Nov 2019 - Aug 2020",
  },
  {
    title: "Frontend Developer Trainee",
    subTitle: "Nugen I.T. Services, Jalandhar, Punjab",
    body: "Built a number of demo projects using Html, Css, Javascript and React.js",
    icon: <WorkIcon />,
    date: "Oct 2019 - Mar 2020",
  },
  {
    title: "Content Writer (Part Time Work during college)",
    subTitle: "Tutorzone, Jalandhar, Punjab",
    body: "Wrote content in english to help Video Lecturers explain physics topics till 10th standard in video lectures.",
    icon: <WorkIcon />,
    date: "Mar 2020 - Aug 2020",
  },
  {
    title: "DAVIET, Jalandhar, Punjab",
    subTitle: "Bachelor's Degree",
    body: "Electronics & Communications",
    icon: <SchoolIcon />,
    date: "2015 - 2019",
  },
];
